'use strict';

import {getFieldsFromAPI} from "../../functions";

export const facingDictionary = () => {
	return {

		"דרום": {
			"en": "South",
			"ru": "",
			"he": "דרום"
		},

		"צפון": {
			"en": "North",
			"ru": "",
			"he": "צפון"
		},
		"מזרח": {
			"en": "East",
			"ru": "",
			"he": "מזרח"
		},

		"מערב": {
			"en": "West",
			"ru": "",
			"he": "מערב"
		},
		"South": {
			"en": "South",
			"ru": "",
			"he": "דרום"
		},
		"North": {
			"en": "North",
			"ru": "",
			"he": "צפון"
		},
		"East": {
			"en": "East",
			"ru": "",
			"he": "מזרח"
		},
		"West": {
			"en": "West",
			"ru": "",
			"he": "מערב"
		}
	};
}

export const dataArrayOfFlat = (object) => {
	return [
		{
			name: 'apt. type',
			data: object.modelName,
			icon: config.features.apartments.infoPointsIcons.aptType,
		},
		{
			name: 'bedrooms',
			data: object.roomNum,
			icon: config.features.apartments.infoPointsIcons.bedrooms,
			exceptions: getFieldsFromAPI.filter().find(el => el.type === 'roomNum')?.exceptions
		},
		{
			name: 'propType',
			data: object.propType,
			icon: config.features.apartments.infoPointsIcons.propType,
		},
		{
			name: 'area',
			data: object.totalSpace,
			icon: config.features.apartments.infoPointsIcons.area,
		},
		{
			name: 'exposure',
			data: object.facing,
			icon: config.features.apartments.infoPointsIcons.exposure,
		},
		{
			name: 'balcony size',
			data: object.balconySize,
			icon: config.features.apartments.infoPointsIcons.balconySize,
		},
		{
			name: 'roof balcony size',
			data: object.roofBalconySize,
			icon: config.features.apartments.infoPointsIcons.roofBalconySize,
		},
		{
			name: 'covered balcony size',
			data: object.coveredBalconySize,
			icon: config.features.apartments.infoPointsIcons.coveredBalconySize,
		},
		{
			name: 'basement size',
			data: object.basementSize,
			icon: config.features.apartments.infoPointsIcons.basementSize,
		},
		{
			name: 'bathrooms',
			data: object.bathRooms,
			icon: config.features.apartments.infoPointsIcons.bathrooms,
		},
		{
			name: 'garden size',
			data: object.gardenSize,
			icon: config.features.apartments.infoPointsIcons.gardenSize, // no icon
		},
		{
			name: 'toilets',
			data: object.toilets,
			icon: config.features.apartments.infoPointsIcons.toilets,
		},
		{
			name: 'accessible',
			data: object.accessible,
			icon: config.features.apartments.infoPointsIcons.accessible,
		},
		{
			name: 'tenantPrice',
			data: object.tenantPrice,
			icon: config.features.apartments.infoPointsIcons.tenantPrice,
		},
		{
			name: 'propPricePerSqm',
			data: object.propPricePerSqm,
			icon: config.features.apartments.infoPointsIcons.propPricePerSqm,
		},
		{
			name: 'treatmentRoom',
			data: object.treatmentRoom,
			icon: config.features.apartments.infoPointsIcons.treatmentRoom,
		},
		{
			name: 'managementFee',
			data: object.managementFee,
			icon: config.features.apartments.infoPointsIcons.managementFee,
		},
		{
			name: 'maintenanceFee',
			data: object.maintenanceFee,
			icon: config.features.apartments.infoPointsIcons.maintenanceFee,
		},
		{
			name: 'storages',
			data: Boolean(object?.storage) ? object.storage : object.storages,
			icon: config.features.apartments.infoPointsIcons.storages,
		},
		{
			name: 'parkings',
			data: Boolean(object?.parking) ? object.parking : object.parkings,
			icon: config.features.apartments.infoPointsIcons.parkings,
		},
	]
}

export const createIconsArray = () => {
	return [
		{
			type: '360',
			crmTitle: 'tours360',
			// plan: 'https://dreamsimages.bmby.com/mazlavidreams/panocontent/tours/b1/index.htm',  // for testing buttons
			disclaimer: 'Lorem dolores ex recusandae rerum.',
			icon: config.features.apartments.tourButtonsIcons["360"],
		},
		{
			type: '360Sample',
			crmTitle: 'sample360',
			plan: 'https://dreamsimages.bmby.com/mazlavidreams/panocontent/tours/b1/index.htm',  // for testing buttons
			disclaimer: 'Lorem dolores ex recusandae rerum.',
			icon: config.features.apartments.tourButtonsIcons["360Sample"],
		},
		{
			type: '2D',
			crmTitle: 'plan2D',
			// plan: 'https://dreamsimages.bmby.com/cnaan/content2d/proj_1.jpg',  // for testing buttons
			// plan: '',  // for testing buttons
			disclaimer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci animi autem delectus deleniti dignissimos, dolores ex exercitationem maxime neque provident, sapiente velit! Architecto eos eum, itaque iure libero recusandae rerum.',
			icon: config.features.apartments.tourButtonsIcons["2D"],
		},
		{
			type: 'keyPlan',
			crmTitle: 'keyPlan',
			// plan: 'https://dreamsimages.bmby.com/cnaan/content2d/proj_1.jpg',  // for testing buttons
			// plan: '',  // for testing buttons
			disclaimer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci animi autem delectus deleniti dignissimos, dolores ex exercitationem maxime neque provident, sapiente velit! Architecto eos eum, itaque iure libero recusandae rerum.',
			icon: config.features.apartments.tourButtonsIcons["2D"],
		},
		{
			type: '3D',
			crmTitle: 'web3D',
			// plan: '',
			icon: config.features.apartments.tourButtonsIcons["3D"],
		},
		{
			type: 'vantage',
			crmTitle: 'vantage',
			// plan: 'https://dreamsimages.bmby.com/mazlavidreams/panocontent/vantages/vantage101a/index.htm?media-index=1&yaw=0',  // for testing buttons
			icon: config.features.apartments.tourButtonsIcons["vantage"],
		},
		{
			type: 'gallery',
			crmTitle: 'gallery',
			icon: config.features.apartments.tourButtonsIcons["gallery"],
		},
		{
			type: 'Ruler',
			crmTitle: '',
			icon: config.features.apartments.tourButtonsIcons["ruler"],
		},
	];
};
